import { API_REQUEST, REGISTER_USER, RESEND_VERIFY_EMAIL, VERIFY_EMAIL } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface RegistrationPayload extends Record<string, unknown> {
    "username": string;
    "password": string;
    "security_question": string,
    "is_custom": boolean,
    "security_answer": string,
    "lang_pref": string;
    "enotif": EnotificationPayload | false;
}

export interface EnotificationPayload {
    "enabled": boolean;
    "firstname": string;
    "lastname": string;
    "phone": string;
}

export const registerUser = (payload: RegistrationPayload, token: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/register/`,
        next: REGISTER_USER,
        method: 'POST',
        data: payload,
        authorization: token,
    }
})

interface VerifyPayload extends Record<string, unknown> {
    username?: string,
    user_profile_id?: string
    code?: string
}

export const verifyEmail = (payload: VerifyPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/verify-email`,
        next: VERIFY_EMAIL,
        method: 'POST',
        data: payload,
    }
})

export const resendEmail = (userProfileId: string, userName: string, isForgotPassResend: boolean): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/resend-verify/${userProfileId}/${userName}`,
        next: RESEND_VERIFY_EMAIL,
        method: 'PUT',
        data: {
            "is_forgot_password_resend": isForgotPassResend
        } 
    }
});
